import type { Component } from "solid-js";

interface MemoryCountIndicatorProps {
  count: number;
}

export const MemoryCountIndicator: Component<MemoryCountIndicatorProps> = (props) => {
  return <span class="rounded-full bg-canvas px-2 py-0.5 text-xs font-medium text-muted-text">{props.count}</span>;
};
